
// --- LOCAL (React on :3000 → Spring Boot direct on :8067) ---
//export const API_BASE_URL = 'http://localhost:8067/api/v1';

// --- PRODUCTION (nginx same-origin: https://datanestedge.com/api/... → :8067) ---
export const API_BASE_URL = '/api/v1';

// --- PRODUCTION absolute domain (optional; prefer /api/v1 above with nginx) ---
// export const API_BASE_URL = 'https://datanestedge.com/api/v1';

// --- PRODUCTION by server IP (HTTP only; no SSL cert for raw IP) ---
// export const API_BASE_URL = 'http://93.127.133.242/api/v1';

export function getConfiguredApiBaseUrl() {
  return API_BASE_URL;
}
